<template>
  <div ref="genericNotification" v-show="show">
    <div class="columns is-mobile is-marginless" v-if="show">
        <div class="column is-narrow is-marginless is-centered" :class="status">
          <span class="icon is-size-4 is-white">
            <i :class="iconClass"></i>
          </span>
        </div>
        <div class="column is-marginless" :class="`${status}-middle`">
            <div v-html="body" :class="size" class="has-text-weight-bold"></div>
        </div>
        <div class="column is-narrow is-marginless" :class="`${status}-middle`" v-if="!hide_close_btn">
          <a class="icon is-size-4" href="#" @click.prevent="closeMessage">
            <i class="far fa-times-circle"></i>
          </a>
        </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      size: {
        type: String,
        default: 'is-size-6'
      },
      hideCloseBtn: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      this.genericNotifier = this.$refs.genericNotification
    },
    data () {
      return {
        body: '',
        iconClass: '',
        show: false,
        duration: 10000,
        genericNotifier: undefined,
        hide_close_btn: undefined, // flag to hide/show close button
        status: '' // status options: is-success, is-warning, is-danger, is-info
      }
    },
    created () {
      window.events.$on('flash', (message, css, hideCloseBtn, duration) => this.display(message, css, hideCloseBtn, duration))
      window.events.$on('closeFlash', () => this.closeMessage())
    },
    watch: {
      show () {
        if (this.show && !this.hide_close_btn) {
          let that = this
          setTimeout(() => {
            this.show = false
          }, that.duration)
        }
      }
    },
    methods: {
      /**
       * Displays notification message globally
       * @param {string} message message to display
       * @param {string} css properties to use
       * @param {boolean} hideCloseBtn flag to hide close btn
       * @param {integer} duration flag to set duration for display
       * @returns {null}
       */
      display (message, css = '', hideCloseBtn, duration) {
        this.hide_close_btn = hideCloseBtn
        this.duration = duration || this.duration

        if (typeof message === 'object') {
          let body = '<ul>'
          for (let msg of message) {
            body += `<li>${msg}</li>`
          }
          body += '</ul'
          this.body = body
        } else {
          this.body = `<p>${message}</p>`
        }

        this.status = css === undefined || css === '' ? 'is-success' : css
        this.iconClass = this.getIcon(css)
        this.show = true
        try {
          this.genericNotifier.scrollIntoView({behavior: 'smooth', block: 'end', inline: 'start'})
        } catch (e) {
          console.log(e.message)
        }
        this.hide()
      },
      /**
       * Hides a notification
       * @param {boolean} instant Whether or not to instantly hide the notification
       * @returns {void}
       */
      hide (instant = false) {
        if (instant) {
          this.show = false
        }
      },
      /**
       * User clicked on the close button
       * @returns {void}
       */
      closeMessage () {
        this.hide(true)
      },
      /**
       * Get the icon class to render on the left of the Notification
       * @param {string} css The default CSS class passed to the notification i.e is-success, is-warning or is-danger
       * @return {string}
       */
      getIcon (css) {
        if (css === 'is-warning') {
          return 'fas fa-exclamation-triangle'
        } if (css === 'is-info') {
          return 'fas fa-info-circle'
        } else if (css === 'is-danger') {
          return 'fas fa-ban'
        }

        return 'fas fa-check'
      }
    }
  }
</script>
<style scoped>
    .is-success-middle {
        background-color: #b9efdd;
    }

    .is-info-middle {
        background-color: #C6E2EF;
    }

    .is-warning-middle {
        background-color: #faddc1;
    }

    .is-danger-middle {
        background-color: #fbcdc6;
    }

    .is-success {
        color:#fff;
        background-color: #16be85;
    }

    .is-warning{
        color:#fff;
        background-color: #fb922c;
    }

    .is-danger {
        color:#fff;
        background-color: #fb492c;
    }

    .is-info {
        color:#fff;
        background-color: #31AAE1;
    }

    a.icon {
        text-decoration: none;
        color: #58595b;
    }
</style>



// WEBPACK FOOTER //
// src/components/FlashMessageStrip.vue